import { VALIDATION_ERRORS } from '@/lib/units/unit-conversion'
import { normalizeRotationDegrees } from '@/lib/transforms/geometry'
import { ROTATION_SLIDER_MAX_DEG } from '../constants/panel-limits'

export function rotationForShapeState(degrees: number): number {
  return normalizeRotationDegrees(Math.round(normalizeRotationDegrees(degrees)))
}

export function clampRotationSliderDegrees(d: number): number {
  if (!Number.isFinite(d)) return 0
  return Math.min(ROTATION_SLIDER_MAX_DEG, Math.max(0, Math.round(d)))
}

/**
 * Parses the rotation text field. Blank and non-numeric input are errors; a number (optionally
 * followed by `°`) is rounded and wrapped into 0–359.
 */
export function parseRotationText(raw: string): { error: string } | { deg: number } {
  const trimmed = raw.trim()

  if (trimmed === '') {
    return { error: VALIDATION_ERRORS.CANT_BE_BLANK }
  }

  const withoutDeg = trimmed.replace(/°\s*$/u, '').trim()
  const parsed = Number(withoutDeg)

  if (!Number.isFinite(parsed)) {
    return { error: VALIDATION_ERRORS.INVALID_NUMBER }
  }

  const clamped = ((Math.round(parsed) % 360) + 360) % 360

  return { deg: rotationForShapeState(clamped) }
}
